/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { CreateUpdateAddressBody } from './address';
import { entityService } from './services';

// #endregion Local Imports

const pathname = '/admin/addresses';

export const AdminAddressApi = {
  all: async (id: string) => {
    try {
      const url = `${pathname}/all/${id}`;

      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  filter: async (id: string, option: any) => {
    try {
      let url = `${pathname}/filter/${id}`;

      const query = serialize(option);
      url += query;

      const response = await entityService.get(url);
      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (id: string, body: CreateUpdateAddressBody) => {
    try {
      const url = `${pathname}/${id}`;

      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: CreateUpdateAddressBody) => {
    try {
      const response = await entityService.patch(`${pathname}/${id}`, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    try {
      const response = await entityService.delete(`${pathname}/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
